export default __webpack_public_path__ + "static/media/fact_sheet31.184bcbdb.png";